import { formatInTimezone } from '../timezone/utils';
export function defaultCashTransactionFilters() {
    return {
        search: '',
        flow: '',
        status: '',
        paymentMethod: '',
        dateFrom: '',
        dateTo: '',
    };
}
export function formatCashUsd(amount, currency = 'USD') {
    const n = Number(amount !== null && amount !== void 0 ? amount : 0);
    if (!Number.isFinite(n))
        return '—';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(n);
}
export function formatCredits(amount) {
    const n = Number(amount !== null && amount !== void 0 ? amount : 0);
    if (!Number.isFinite(n))
        return '—';
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
    }).format(n);
}
export function formatCostRate(rate) {
    const n = Number(rate !== null && rate !== void 0 ? rate : 0);
    if (!Number.isFinite(n))
        return '—';
    return `${(n * 100).toFixed(2)}%`;
}
export function formatCostRateDetail(rate) {
    const n = Number(rate !== null && rate !== void 0 ? rate : 0);
    if (!Number.isFinite(n))
        return '—';
    return `${formatCostRate(n)} (${n.toFixed(2)})`;
}
export function formatCashDateTime(iso, timezone = Intl.DateTimeFormat().resolvedOptions().timeZone) {
    return formatInTimezone(iso, timezone);
}
export function toDatetimeLocalValue(iso) {
    const d = iso instanceof Date ? iso : new Date(iso !== null && iso !== void 0 ? iso : Date.now());
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
export function datetimeLocalToIso(local) {
    const d = new Date(local);
    return Number.isFinite(d.getTime()) ? d.toISOString() : new Date().toISOString();
}
export function computeExpectedCash(credits, costRate) {
    const c = Number(credits);
    const r = Number(costRate);
    if (!Number.isFinite(c) || !Number.isFinite(r) || c <= 0 || r <= 0)
        return 0;
    return Math.round(c * r * 100) / 100;
}
